// extracted by mini-css-extract-plugin
export var container = "_hd-0";
export var content = "_hd-3";
export var customerTitle = "_hd-4";
export var empty = "_hd-5";
export var gray = "_hd-6";
export var header = "_hd-7";
export var info = "_hd-8";
export var loading = "_hd-2";
export var loadingCard = "_hd-9";
export var oneLine = "_hd-a";
export var personName = "_hd-e";
export var pillContainer = "_hd-b";
export var selected = "_hd-1";
export var text = "_hd-c";
export var twoLines = "_hd-d";
export var unread = "_hd-f";
export var unreadIndicator = "_hd-g";